
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "@ember-data/canary-features/-embroider-implicit-modules.js";
import "@ember-data/private-build-infra/-embroider-implicit-modules.js";
